export const TIMEOUT = 10 * 6 * 1000

export default function () {
  return this.sendEventWithCallback('oauth.fb', {}, TIMEOUT)
}
